/**
 * A UI Notification
 *
 * @typedef {Object} Notification
 * @property {string} title -
 * @property {string} message -
 * @property {number} [duration=5000] - in ms
 * @property {string} [position="bottomRight"] -"topLeft" | "topCenter | "topRight" | "bottomLeft" | "bottomCenter" | "bottomRight"
 * @property {string} [type="info"] - "info" | "error" | "warning" | "success"
 * @property {boolean} [autoClose=true]
 * @property {boolean} [textRender=false]
 *
 */

const serviceShowRequestQueue = [];
let textRender = false;
const textRenderListeners = new Set();

const serviceImplementation = {
  _hide: () => console.warn('hide() NOT IMPLEMENTED'),
  _show: showArguments => {
    serviceShowRequestQueue.push(showArguments);

    console.warn('show() NOT IMPLEMENTED');
  },
  textRender: textRender,
};

class UINotificationService {
  static REGISTRATION = {
    name: 'uiNotificationService',
    altName: 'UINotificationService',
    create: (): UINotificationService => {
      return new UINotificationService();
    },
  };

  /**
   *
   *
   * @param {*} {
   *   hide: hideImplementation,
   *   show: showImplementation,
   * }
   */
  public setServiceImplementation({ hide: hideImplementation, show: showImplementation }): void {
    if (hideImplementation) {
      serviceImplementation._hide = hideImplementation;
    }
    if (showImplementation) {
      serviceImplementation._show = showImplementation;

      while (serviceShowRequestQueue.length > 0) {
        const showArguments = serviceShowRequestQueue.pop();
        serviceImplementation._show(showArguments);
      }
    }
  }
  public setTextRenderHandler(textTitleRender: boolean): void {
    textRender = textTitleRender;
    textRenderListeners.forEach(listener => listener(textTitleRender));

    return;
  }

  public subscribeToTextRenderChanges(callback: (value: boolean) => void): () => void {
    textRenderListeners.add(callback);
    return () => textRenderListeners.delete(callback);
  }

  public getTextRenderHandler(): boolean {
    return textRender;
  }
  /**
   * Hides/dismisses the notification, if currently shown
   *
   * @param {number} id - id of the notification to hide/dismiss
   * @returns undefined
   */
  public hide(id: string) {
    return serviceImplementation._hide({ id });
  }

  /**
   * Create and show a new UI notification; returns the
   * ID of the created notification.
   *
   * @param {Notification} notification { title, message, duration, position, type, autoClose}
   * @returns {number} id
   */
  show({
    title,
    message,
    duration = 5000,
    position = 'bottomRight',
    type = 'info',
    autoClose = true,
  }) {
    return serviceImplementation._show({
      title,
      message,
      duration,
      position,
      type,
      autoClose,
    });
  }
}

export default UINotificationService;
